'use strict';

exports.__esModule = true;
exports.INSURANCE_ROUTE = undefined;
exports.getInsurance = getInsurance;
exports.updateInsurance = updateInsurance;
exports.connectInsurance = connectInsurance;

var _apiClient = require('../../network/api-client');

var _apiClient2 = _interopRequireDefault(_apiClient);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INSURANCE_ROUTE = '/api/quiqee';

var quiqeeInsurance = {
  getInsurance: getInsurance,
  updateInsurance: updateInsurance,
  connectInsurance: connectInsurance
};

exports.INSURANCE_ROUTE = INSURANCE_ROUTE;
exports.default = quiqeeInsurance;


var isRequired = function isRequired() {
  throw new Error('Missing required parameter');
};

/**
 * Get information about insurance.
 * @returns {promise} containing the data about insurance
 */
function getInsurance() {
  var URL = '' + _config2.default.api.API_INSURANCE_URL + INSURANCE_ROUTE;
  return _apiClient2.default.get({ path: URL });
}

/**
 * Get me information
 * @param {string} params - Attributes
 * @param {number} providerId - id of the provider
 * @param {string} providerSlug - slug of the provider
 * @param {number} quiqupId - id of the Quiqee
 * @returns {promise} containing updated data about the insurance
 */
function updateInsurance() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      email = _ref.email,
      providerId = _ref.providerId,
      providerSlug = _ref.providerSlug,
      quiqupId = _ref.quiqupId;

  var URL = '' + _config2.default.api.API_INSURANCE_URL + INSURANCE_ROUTE;
  return _apiClient2.default.put({ path: URL, data: { email: email, providerId: providerId, providerSlug: providerSlug, quiqupId: quiqupId } });
}

/**
 * Get me information
 * @param {string} params - Attributes
 * @param {number} providerId - id of the provider - required
 * @param {string} providerSlug - slug of the provider - required
 * @param {number} quiqupId - id of the Quiqee
 * @returns {promise} containing data about connected insurance
 */
function connectInsurance() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      email = _ref2.email,
      _ref2$providerId = _ref2.providerId,
      providerId = _ref2$providerId === undefined ? isRequired() : _ref2$providerId,
      _ref2$providerSlug = _ref2.providerSlug,
      providerSlug = _ref2$providerSlug === undefined ? isRequired() : _ref2$providerSlug,
      quiqupId = _ref2.quiqupId;

  var URL = '' + _config2.default.api.API_INSURANCE_URL + INSURANCE_ROUTE;
  return _apiClient2.default.post({ path: URL, data: { email: email, providerId: providerId, providerSlug: providerSlug, quiqupId: quiqupId } });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/insurance/quiqee/index.js
// module id = 1198
// module chunks = 0